<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap coaching-finish-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약 요청 코칭</h3>
      </div>
      <div class="body-wrap">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>{{ request.startDate }}({{ request.day }}) {{ request.startTime }}~{{ request.endTime }} ({{ request.time }}분)</p>
        </div>
        <div class="coach">
          <div class="w-100per clear">
            <div class="w-50per float-left txt-left">
              <p class="company">{{ request.companyName }}</p>
            </div>
            <div class="w-50per float-left txt-right" @click="viewSurvey()">
              <span class="survey">서베이 보기</span>
            </div>
          </div>
          <div class="info">
            <h3>
              {{ request.userName }} <span>{{ request.userGrade }}</span>
            </h3>
            <h4>{{ request.sessionType }} 코칭 <span></span>{{ request.currentSession }}회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" class="ml-20" @click="viewMessage()" />
              </li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>관심 코칭 주제</h3>
              <p class="preline">
                <font v-for="(item, index) in embedded" :key="index" :class="{ active: index == 0 }">
                  {{ index + 1 }}. {{ item.parentSubject }} - {{ item.subject }}<br />
                </font>
              </p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">{{ request.coarchingSubject }}</p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">{{ request.coarchingEtc }}</p>
            </li>
          </ul>

          <!-- 성찰노트 -->
          <!-- <ul>
                        <li>
                            <h3>코칭 후 새롭게 알게 된 점</h3>
                            <p class="preline">코칭 이전의 모습과 많이 달라진 것을 많이 느낍니다. 
                                구성원들에 대한 생각을 다시 하게 된 것 같고, 현재의 위치에서 성과도 놓치지 않는 방법을 배운 시간이었습니다.
                            </p>
                        </li>
                        <li>
                            <h3>코칭 과제 및 실행 계획</h3>
                            <p class="preline">구성원을 조금 더 세심하게 챙기며 그들이 성장하는 모습을 기대하며, 
                            </p>
                        </li>
                        <li>
                            <h3>코칭 후 기대 하는 점</h3>
                            <p class="preline">구성원을 조금 더 세심하게 챙기며 그들이 성장하는 모습을 기대하며, 
                            </p>
                        </li>
                    </ul> -->
        </div>
        <div class="w-90per mg-auto clear">
          <div class="cancel-btn w-50per float-left">
            <span @click="cacnel()">취소하기</span>
          </div>
          <div class="modify-btn w-50per float-left" @click="scheduleChange()">
            <span class="point">수정하기</span>
          </div>
        </div>
        <div class="coaching-btn">
          <button @click="journalWrite()">예약 확정하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "reservation_coaching_request",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    request: {},
    embedded: [],
    isLoadingPop: false,
  }),
  components: {
    incBack,
    Loading,
  },
  mounted() {
    this.getReservationDetail();
  },
  methods: {
    getReservationDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.request = res.data.contentinfo.coarchReservationList;
            let session = this.request.sessionPer.split("/");
            this.request.currentSession = session[0];

            this.request.startTime = dayjs(this.request.startDate).format("HH:mm");
            this.request.endTime = dayjs(this.request.endDate).format("HH:mm");
            let timeValue = {
              startTime: this.request.startTime,
              endTime: this.request.endTime,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.request.time = this.$store.state.coachingTime;

            this.request.startDate = dayjs(this.request.startDate).format("YYYY-MM-DD").replace(/-/g, "/");
            this.$store.commit("setCoachingDays", dayjs(this.request.startDate).day());
            this.request.day = this.$store.state.coachingDays;

            this.request.startDate = dayjs(this.request.startDate).format("YYYY.MM.DD");

            this.embedded = res.data.contentinfo.userEmbeddedSurvey;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cacnel() {
      if (confirm("해당 코칭을 취소 하시겠습니까?")) {
        this.isLoadingPop = true;
        let form = new FormData();
        form.append("sessionIdx", this.sessionIdx);
        form.append("courseIdx", this.request.courseIdx);
        this.axios
          .post("/front/coarch/reserved/cancel", form)
          .then((res) => {
            if (res.data.success) {
              alert("예약이 취소 되었습니다.");
              this.isLoadingPop = false;
              this.$router.replace({ name: "coaching_request" });
            } else {
              alert("예약 취소 실패");
              this.isLoadingPop = false;
            }
          })
          .catch((err) => {
            this.isLoadingPop = false;
            console.log(err);
          });
      }
    },
    viewMessage() {
      this.$router.push({ name: "message", params: { userIdx: this.request.userIdx } });
    },
    viewSurvey() {
      this.$router.push({
        name: "embedded_survey_report",
        params: { userIdx: Number(this.request.userIdx), sessionIdx: Number(this.sessionIdx) },
      });
    },
    scheduleChange() {
      this.$router.push({ name: "schedule_change", params: { sessionIdx: Number(this.sessionIdx) } });
    },
    journalWrite() {
      if (confirm("해당 코칭 건 예약을 확정 하시겠습니까?")) {
        // this.$router.push("my_coaching");
        this.isLoadingPop = true;
        let form = new FormData();
        form.append("sessionIdx", this.sessionIdx);
        form.append("courseIdx", this.request.courseIdx);
        this.axios
          .post("/front/coarching/reservation/confirmed", form)
          .then((res) => {
            if (res.data.success) {
              alert("예약 확정이 완료되었습니다.");
              this.isLoadingPop = false;
              this.$router.replace({ name: "my_coaching" });
            } else {
              alert("예약 확정 실패");
              this.isLoadingPop = false;
            }
          })
          .catch((err) => {
            this.isLoadingPop = false;
            console.log(err);
          });
      }
    },
  },
};
</script>
